module.exports = __webpack_public_path__ + "img/9788962606256.36a27d6a.jpg";